import { render, staticRenderFns } from "./RequestsAdmin.vue?vue&type=template&id=7dd18572"
import script from "./RequestsAdmin.vue?vue&type=script&lang=js"
export * from "./RequestsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports